module.exports = __webpack_public_path__ + "static/images/callout_1.80d97fef7690688b63174d302fca77ad.jpg";